import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { SheetDescription, SheetHeader, SheetTitle } from "../ui/sheet.tsx";
import { MobileItem } from "./MobileItem.tsx";
import type {
  MenuCtx,
  ResponsiveMenuItem,
  ResponsiveMenuPage,
} from "./types.ts";

export function MobileSheet<T extends string>({
  page,
  canGoBack,
  onBack,
  items,
  ctx,
}: {
  page?: ResponsiveMenuPage<T>;
  canGoBack: boolean;
  onBack: () => void;
  items: ResponsiveMenuItem<T>[];
  ctx: MenuCtx;
}) {
  return (
    <div className="flex flex-col">
      <SheetHeader className="flex items-center border-b px-3 py-3 gap-0">
        <SheetTitle className="w-full flex items-center">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={canGoBack ? onBack : undefined}
            disabled={!canGoBack}
            aria-label="Back"
            aria-hidden={!canGoBack}
            tabIndex={canGoBack ? 0 : -1}
            className={!canGoBack ? "invisible pointer-events-none" : undefined}
          >
            <ChevronLeft className="size-5" />
          </Button>

          <div className="min-w-0 flex-1 font-medium">{page?.title ?? ""}</div>
        </SheetTitle>
        <SheetDescription className="sr-only">Menu</SheetDescription>

        <div className="w-10" />
      </SheetHeader>

      <div className="px-3 py-2">
        {items.map((item) => (
          <MobileItem key={item.key} item={item} ctx={ctx} />
        ))}
      </div>
    </div>
  );
}
